module.exports = fox => {
	'use strict';

	const UA_PARSER = require('ua-parser-js');

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'emailNotValid': function() {return fox.i18n.getTranslation('emailNotValid', 'Email is not valid', 'tooltip');},
				'fieldNotEmpty': function() {return fox.i18n.getTranslation('fieldNotEmpty', 'Fields shouldn\'t be empty', 'tooltip');}
			};

			return translation[alias] || '';
		}
	};

	const CAPTCHA_ERROR_CODES = [6030, 6031, 6032];

	fox.registerWidget('Login_Wizard_LoginForm', {
		configure() {
			this.registerOptions('', {
				template: 'member_login',
				container: '.login-form-wrapper',
				widgets: {
					snManager: {
						widget: 'SocialNetwork_Manager',
						autoRender: true,
						mode: 'signin',
						template: 'socialnetwork_oauth_signin_container',
						'embed.container': '.social-fields',

						list: {
							'tpl.row': 'socialnetwork_oauth_signin',
							'embed.container': '#items-block',
							handleDom: {
								socialClick: {
									target: 'a.soc-button',
									event: 'click',
									callback: '@parent:socialClickHandler'
								}
							},
							'hooks.onStopRendering': '@parent @parent:onNetworksStopRendering'
						},

						'handleWom.successLogin': {
							widget: '@this',
							event: 'successLogin',
							callback: '@parent:snLogin'
						},
						'handleWom.readyForReg': {
							widget: '@this',
							event: 'readyForReg',
							callback: '@parent:snConnect'
						},
						'handleWom.readyFor2FaLogin': {
							widget: '@this',
							event: 'readyFor2FaLogin',
							callback: '@parent:snLogin'
						},
						'handleWom.errorIn2FaLogin': {
							widget: '@this',
							event: 'errorIn2FaLogin',
							callback: '@parent:sn2FaLoginError'
						}
					},

					form: {
						widget: 'DomForm',
						formSelector: '#login-form',
						elements: {
							email: {
								validators: [
									{
										validator: 'regexp',
										options: {type: 'email'},
										message:  this.getTextMessage('emailNotValid')
									},
									(value) => {
										return {
											result: value.length > 0,
											message: this.getTextMessage('fieldNotEmpty')
										};
									}
								]
							},
							passwd: {
								validators: [
									(value) => {
										return {
											result: value.length > 0,
											message: this.getTextMessage('fieldNotEmpty')
										};
									}
								]
							}
						}
					},

					authApi: {
						widget: 'Api',
						method: 'site.authorizer.securedAuth',
						httpMethod: 'post',
						encodePost: true
					},

					recaptcha: {
						widget: 'RecaptchaFox'
					}
				},

				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: this._handleFormValidation.bind(this)
					}
				},
				handleDom: {
					snRegister: {
						target: '#reg-from-login',
						event: 'click',
						callback: 'snRegister'
					},
					formButtonSubmit: {
						target: '#form-submit',
						event: 'click',
						callback: '_submit'
					},
					switchToForgotForm: {
						target: '#change-form-forgot',
						event: 'click',
						callback: 'showForgotPasswordForm'
					},
					submitByEnter: {
						event: 'keyup',
						target: 'input',
						eventChecker: function (e) { return e.keyCode === 13 },
						callback: '_submit'
					}
				}
			});

			return this.callParent('configure', arguments);
		},

		init() {
			return this.callParent('init', arguments);
		},

		running() {
			this.callParent('running', arguments);
		},

		rendering() {
			this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
		},

		addedToDom() {
			this.callParent('addedToDom', arguments);

			this._recaptcha = this.wom1('#recaptcha');

			if (this._recaptcha.isNeed()) {
				this._recaptcha.load();
			}
		},

		_submit(el, w, alias, e) {
			fox.jQuery.Event(e).preventDefault();

			this.wom1('#form').submit().then(result => {
				if (result === false) {
					return;
				}

				this.togglePreloader(true);

				this.submit().then(resp => {
					var response = resp.params.answer.response;

					this.togglePreloader(false);

					if (response.authentificationKey) {
						this.showVerificationForm(response);
						return;
					}

					this.login(response);
				})
				.catch(err => {
					var p    = err && err.params ? err.params : {answer: {code: -1, reason: 'Captcha failed. Please try again.'}};
					var code = p.answer.code;

					this.togglePreloader(false);

					if (this._recaptcha.isNeed()) {
						this._recaptcha.load('onError');
					}

					if (fox.inArray([1053, 1054], code)) {
						this.show2FaError(p.answer);
						return;
					}

					if (fox.inArray(CAPTCHA_ERROR_CODES, code)) {
						this.formSubmitError(p, 'captcha');
						return;
					}

					this.formSubmitError(p);
				});
			});
		},

		submit() {
			return this.getUDID().then(_udid => {
				var data = this.wom1('#form').getValues();

				fox.merge(data, { udid: _udid, device: this.getDeviceData() });

				if (!this._recaptcha || !this._recaptcha.isNeed()) {
					return this.wom1('#authApi').psend(data);
				}

				return this._recaptcha.getToken('login').then(token => {
					if (this._recaptcha.captchaVariant === 'invisible') {
						data['g-recaptcha-invisible-response'] = token;
						return this.wom1('#authApi').psend(data);
					}

					if (!token) {
						return Promise.reject({ params: { answer: { code: -1, reason: 'Please complete the captcha' } } });
					}

					data['g-recaptcha-response'] = token;
					return this.wom1('#authApi').psend(data);
				});
			});
		},

		formSubmitError(err, type) {
			var message = type === 'captcha'
				? 'Please complete the captcha below to proceed.'
				: err.answer.reason;

			this.showErrorMessage(message);
			this.togglePreloader(false);
		},

		showErrorMessage(message) {
			var errItem = $('.notice-container .txt p').text(message);
			this.errorsContainer.html('').append(errItem);
			this.errorBox.show();
		},

		snLogin(data) {
			if (!fox.isEmpty(data.twoFactorAuth)) {
				this.showVerificationForm(data.twoFactorAuth);
				return;
			}

			this.login(data);
		},

		snConnect(data, w) {
			this.clientProfile = data;
			this.dom1('#sn-login-' + w.appName + '-notice').style.display = 'block';
		},

		snRegister() {
			fox.Consent.checkCookie('snProfile').then(() => {
				fox.cookie.set('snProfile', JSON.stringify(this.clientProfile));
			});

			fox.site.gotoPage('home/registration');
		},

		sn2FaLogin(eventData) {

		},

		login(response) {
			const redirectUrl = this.getOption('redirectUrl');

			if (response && response[0] === 'studio') {
				window.location.assign(['https://agency.', window.location.host, '/'].join(''));
			}

			if (!response.member) {
				// error
				return;
			}

			fox.log('logged in, hash: "' + response.hash + '", member: ' + response.member.collection);

			if (redirectUrl) {
				fox.Navigator.update({0: fox.isFunction('redirectUrl') ? redirectUrl() : redirectUrl }, true);
			}

			window.location.reload(true);
		},

		togglePreloader(state) {
			var btn = this.dom1('#form-submit');

			if (!btn) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', btn);
		},

		_handleFormValidation(formData, form) {
			formData.forEach(resp => {
				var $elm = $(this.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					this.showErrorMessage(resp.message, resp.field);
					$elm.addClass('error');
					return;
				}

				$elm.removeClass('error');
			});
		},

		showVerificationForm(data) {
			this.wom1('@parent').showVerificationForm(data);
		},

		getDeviceData() {
			var data = new UA_PARSER();
			var _replace = (obj) => {
				fox.each(obj, (val, key) => {
					if (!val) {
						obj[key] = '';
					}
				});

				return obj;
			};

			return {
				device: _replace(data.getDevice()),
				os: _replace(data.getOS()),
				browser: data.getBrowser().name
			}
		},

		getUDID() {
			return this.wom1('@parent').getUDID();
		},

		showForgotPasswordForm() {
			this.wom1('@parent').showForgotPasswordForm();
		},

		getTextMessage(alias) {
			return _.getTranslation(alias);
		},

		onNetworksStopRendering() {
			const buttons = this.wom1('#snManager #list').dom('a.soc-button');

			this.getUDID().then(_udid => {
				buttons.forEach(elm => {
					const reqUrl = elm.getAttribute('data-request-url')
					elm.setAttribute('data-request-url', `${reqUrl}&transitParams[udid]=${_udid}`);
				});
			});
		},

		sn2FaLoginError(data) {
			this.show2FaError(data.error);
		},

		show2FaError(err) {
			if (err.code === 1053) {
				this.wom1('@parent').showError(err.reason);
				return;
			}

			if (err.code === 1054) {
				this.wom1('@parent').showError(err.reason);
				return;
			}
		}

	});
};



// WEBPACK FOOTER //
// ./components/login-wizard/widget/login-form.es.js